import {z} from "zod/v4-mini"
import {registerTemplateGraphNode, getTemplateNodeReturns, externalId} from "@cm/template-nodes"
import type {TemplateNodeDefinition} from "@cm/template-nodes"
import {MattressExport, type MattressExportParameters} from "#mattress/nodes/mattress-export"
import {mattressCurveLike} from "#mattress/validation"
import type {MattressCurveLikeNode} from "#mattress/role-markers"
import {MattressCurveInfo} from "#mattress/nodes/component/mattress-component-interface-descriptors"

export type MattressCurveExportParameters = MattressExportParameters<MattressCurveLikeNode>

const definition: TemplateNodeDefinition<MattressCurveExportParameters> = {
    nodeClass: "MattressCurveExport",
    validation: {
        parameters: z.object({
            name: z.string(),
            id: externalId,
            node: z.nullable(mattressCurveLike),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MattressCurveExport extends MattressExport<MattressCurveLikeNode> {
    public override get definition() {
        return definition
    }

    protected override get outputType() {
        return "mattressCurve" as const
    }

    protected override get InfoClass() {
        return MattressCurveInfo
    }
}
